module.exports = {
    primary: {
        50: '#eef6ff',
        100: '#d9ebff',
        200: '#bcdbff',
        300: '#8fc2ff',
        400: '#5ba1ff',
        500: '#0076e1',
        600: '#005bb7',
        700: '#00458b',
        800: '#003a74',
        900: '#003061',
        950: '#001428',
    },
    danger: '#ef4444',
    success: '#27c93f',
    warning: '#f59e0b',
    gray: {
        50: '#f9fafb',
        100: '#f3f4f6',
        200: '#e5e7eb',
        300: '#d1d5db',
        400: '#9ca3af',
        500: '#6b7280',
        600: '#4b5563',
        700: '#374151',
        800: '#1f2937',
        900: '#111827',
    },
    white: '#ffffff',
    softBlue: '#eef6ff',
    layout: {
        bg: '#f8fafc',
    },
    editor: {
        bg: '#1e293b',
        header: '#0f172a',
        red: '#ff5f56',
        yellow: '#ffbd2e',
        green: '#27c93f',
    }
};

const palette = {
    primary: module.exports.primary[500],
    secondary: module.exports.primary[900],
    accent: module.exports.primary[500],
    info: module.exports.primary[400],
    light: module.exports.primary[200],
    success: module.exports.success,
    danger: module.exports.danger,
    warning: module.exports.warning,
    gray: module.exports.gray[100],
    gray_200: module.exports.gray[200],
    gray_300: module.exports.gray[300],
    gray_400: module.exports.gray[400],
    gray_600: module.exports.gray[600],
    white: module.exports.white,
    dark: module.exports.gray[900],
    softBlue: module.exports.softBlue,
    blueMedium: module.exports.primary[600],
    blueDark: module.exports.primary[700],
    blueNavy: module.exports.primary[800],
    // Expanded palette for varied charts
    purple: '#a855f7',
    orange: '#f97316',
    pink: '#ec4899',
    cyan: '#06b6d4',
    indigo: '#6366f1',
    chart: [
        '#354E96', 
        '#4F8FF7', 
        '#1FBED9', 
        '#2CC0AF', 
        '#28C08E', 
        '#F6A824', 
        '#FA812E', 
        '#A27DF8', 
    ]
};

module.exports.palette = palette;
